export default __webpack_public_path__ + "static/media/ic_cayman_islands.2a4f38a3.svg";